import { Link } from 'react-router';
import { IconLogout, IconSettings } from '@tabler/icons-react';
import { routes } from '~/shared/constants/routes';
import { type Item } from './components';

export const links = (onLogout?: VoidFunction): Item[] => {
    return [
        {
            component: Link,
            title: 'Настройки',
            componentProps: {
                to: routes.settings,
            },
            icon: <IconSettings size={16} />,
        },
        {
            title: 'Выход',
            icon: <IconLogout size={16} />,
            onClick: onLogout,
            dividerBefore: true,
        },
    ];
};
